import styled, { css } from 'styled-components'

import { features } from '@h2/components/media'

const headerSibling = css`
  margin: 0 0 20px 0;
  padding: 0;
`
const headerOnly = css`
  margin: 0;
  padding: 15px 0;
`
const Wrap = styled.div`
  > h2 {
    ${({ isNamePanel }) => (isNamePanel ? headerSibling : headerOnly)};

    > span:last-child {
      display: none;
    }
  }

  > div {
    gap: 15px;
    display: ${({ isNamePanel }) => (isNamePanel ? 'flex' : 'none')};
  }

  > p,
  > img {
    display: none;
  }

  @media (${features.minWidth.laptop}) {
    > h2 {
      ${headerSibling};

      > span:first-child {
        display: none;
      }

      > span:last-child {
        display: inline;
      }
    }

    > div {
      display: flex;
      gap: normal;
      flex-direction: column;
    }

    > p {
      display: block;
    }

    > img {
      display: inline;
    }
  }
`

export { Wrap }
